import { Avatar, Button, Divider, notification } from "antd";
import React, { useEffect, useState } from "react";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import "./TopNavbar.css";
import { MenuOutlined, LogoutOutlined ,UpOutlined} from "@ant-design/icons";
import { RiProfileLine } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import "../../Assets/Css/Global.css";
import { LogOutApi } from "../../Services/Login";


import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Space } from 'antd';

const items = [
  {
    label: (<p className="mb-2"><b>HR Admin</b></p>),
    key: 'admin',
  },
  {
   label: (<p className="m-0"><b>Employee</b></p>),
    key: 'newUser',
  },
  
];

export default function TopNavbar({ setIsNavbarOpen }) {
  const [api, contextHolder] = notification.useNotification();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const navigate = useNavigate();
  const type = sessionStorage.getItem("userType");

  // console.log(type, "checking type");

  const handleLogout = async () => {
    
    try {
      const data = await LogOutApi();

      sessionStorage.removeItem("firstName");
      sessionStorage.removeItem("lastName");
      sessionStorage.removeItem("fullName");
      sessionStorage.removeItem("isLoggedIn");
      sessionStorage.removeItem("userType");
      navigate("/auth");
      console.log(data);

      if (!data.data.success) {
        api.error({
          message: "Error while Logging Out",
          description: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };

  const handleMenuClick = ({ key }) => {
    console.log(key,'checkign kye')

    if(key==='newUser') {
          sessionStorage.setItem("userType", "newUser");
          navigate("/new-user/personal");
    }else if (key==='admin'){
         sessionStorage.setItem("userType", "admin");
          navigate("/admin/employees-verification");
    }
  

  
};

  // const auth = sessionStorage.getItem('authorization')

const roles = sessionStorage.getItem('authorization')?.split(',') || [];

console.log(roles,'checking rolex', roles.includes('EMPLOYEE') ,roles.includes('EMPLOYEE') )


  return (
    <>
      {contextHolder}

      
      <Navbar expand="lg" className="navbar-style mb-2 px-4 py-0 h-[65px]">
        <Button className="collapse-button text-dark" ghost>
          <MenuOutlined
            style={{ fontSize: "26px", color: "white" }}
            onClick={() => setIsNavbarOpen(true)}
          />
        </Button>
        <Navbar.Brand className="text-white font-bold">HRMS</Navbar.Brand>


       
  <div className="flex ">
    <div className="  self-center  mr-3">
    {roles?.includes('EMPLOYEE') && roles?.includes("ADMIN") &&  <Dropdown
        menu={{ items , onClick: handleMenuClick}}
        trigger={['click']}
        open={dropdownOpen}
        placement="bottomRight" 
        onOpenChange={(flag) => setDropdownOpen(flag)}
        
      >
        <span
          className="cursor-pointer text-[12px]  inline-flex items-center"
          onClick={(e) => e.preventDefault()}
        >
          {dropdownOpen ? <UpOutlined /> : <DownOutlined />}
        </span>
      </Dropdown>}
     
    </div>
        <Nav>
          <NavDropdown
            title={
              <Avatar className="bg-info">
                <span className="fw-bold">
                  {sessionStorage.getItem("firstName") !== null &&
                    `${sessionStorage.getItem("firstName")[0]}${
                      sessionStorage.getItem("lastName")[0]
                    }`}
                </span>
              </Avatar>
            }
            id="basic-nav-dropdown"
          >
            <NavDropdown.Item
              onClick={() =>
                navigate(`/${type === "newUser" ? "user" : type}/profile`)
              }
            >
              <div className="w-full flex justify-start">
                <RiProfileLine
                  className="mr-2 mt-1"
                  style={{ verticalAlign: "text-bottom", fontSize: "18px" }}
                />
                <span>Profile</span>
              </div>
            </NavDropdown.Item>
            <Divider className="my-1" />
            <NavDropdown.Item onClick={handleLogout}>
              <LogoutOutlined
                className="mr-2"
                style={{ verticalAlign: "text-middle" }}
              />
              <span>Log Out</span>
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
        </div>
        {/* </Navbar.Collapse> */}
      </Navbar>
    </>
  );
}
